import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import logo from "../assests/Images/logo.png";
import AuthContext from "../services/AuthContext";

const settings = [
  {
    title: "Profile",
    path: "/admin/profile",
    icon: <UserOutlined style={{ color: "black" }} />,
  },
  {
    title: "Logout",
    path: "/logout",
    icon: <LogoutOutlined style={{ color: "black" }} />,
  },
];

function ResponsiveAppBar() {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleredirect = (title, url) => {
    if (title === "Logout") {
      logout();
      navigate("/");
    } else {
      navigate(url);
    }
  };

  return (
    <AppBar position="static" sx={{ background: "#e5e5e5" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img
            src={logo}
            alt="logo"
            style={{ width: "100px" }}
            onClick={() => navigate("/admin/dashboard")}
          />
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {/* other optiosn will come here */}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt="Remy Sharp"
                  src="/static/images/avatar/2.jpg"
                  sx={{ background: "#797373" }}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting.title} onClick={handleCloseUserMenu}>
                  {setting.icon && <ListItemIcon>{setting.icon}</ListItemIcon>}
                  <Typography
                    sx={{ textAlign: "center" }}
                    onClick={() => handleredirect(setting.title, setting.path)}
                  >
                    {setting.title}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
